import { FunctionComponent, PropsWithChildren } from "react";
import { cx } from "class-variance-authority";
import { CircleIcon, Icon } from "../Icons";

export interface LargeInfoCardProps {
  className?: string;
  iconClassName?: string;
  Icon: Icon;
}

/**
 *
 */
export const LargeInfoCard: FunctionComponent<
  PropsWithChildren<LargeInfoCardProps>
> = ({ className, Icon, children, ...props }) => {
  return (
    <div
      className={cx(
        "relative flex max-w-lg flex-col items-center  justify-center gap-5 rounded-lg p-10 pt-2",
        className
      )}
    >
      <CircleIcon className=" text-red-100" icon={Icon} size="2xl" />
      {children}
    </div>
  );
};

export default LargeInfoCard;
